import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: '$enableTCSFooter',
  initialState: false,
  reducers: {
    setEnableTCSFooter(_, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setEnableTCSFooter } = slice.actions;
export default slice.reducer;
